import { Component } from '@angular/core';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-content-pool',
    templateUrl: './content-pool.component.html',
    styleUrls: ['./content-pool.component.scss'],
    providers: [DynamicContentService],
    standalone: false
})
export class ContentPoolComponent {
  dynamicContentTypes = [
    { value: 'information', title: 'Informationen' }/*, { value: 'activity', title: 'Aktivitäten' }, { value: 'alphabet', title: 'Alphabet' }, { value: 'offer', title: 'Angebote' },
    { value: 'breaking-news', title: 'Breaking News' }, { value: 'event', title: 'Events' }, { value: 'feedback', title: 'Feedback' }, { value: 'gallery', title: 'Gallery' },
    { value: 'gastronomy', title: 'Gastronomie' }, { value: 'memory', title: 'Memory' }, { value: 'new', title: 'News' }*/, { value: 'public-transport', title: 'Öffentlicher Verkehr' }/*,
    { value: 'opening-hours', title: 'Öffnungszeiten' }, { value: 'person', title: 'Personen' }, { value: 'quiz', title: 'Quiz' }, { value: 'restaurant', title: 'Restaurants' },
    { value: 'screensaver', title: 'Screensaver' }, { value: 'social-media', title: 'Social Media' }, { value: 'ticker', title: 'Ticker' }, { value: 'voting', title: 'Voting' },
    { value: 'webcam', title: 'Webcams' }, { value: 'important-numbers', title: 'Wichtige Nummern' }, { value: 'roomservice', title: 'Zimmerservice' }*/
  ];

  columns = [{ prop: 'title', name: 'Typ' }];

  constructor(private router: Router) {
  }

  public openType(el) {
    this.router.navigate(['content-pool', el.row.value]);
  }
}
